import React, { memo, useCallback } from 'react'
import { Input } from 'antd';
import { SearchOutlined } from "@ant-design/icons";

type Props = {
  id?: string;
  placeholder?: string;
  value?: string;
  className?: string;
  suffix?: React.ReactNode;
  onChange?: (value: string) => void;
  onSearch?: (value: string) => void;
  onBlur?: (value: string) => void;
}

function AppSearch({ id, placeholder, value, className, onChange, onBlur, onSearch, suffix }: Props) {
  const handleChange = useCallback((evt: React.ChangeEvent<HTMLInputElement>) => onChange?.(evt.currentTarget.value), [onChange]);
  const handleSearch = useCallback((evt: React.KeyboardEvent<HTMLInputElement>) => onSearch?.(evt.currentTarget.value), [onSearch]);
  const handleBlur = useCallback((evt: React.FocusEvent<HTMLInputElement>) => onBlur?.(evt.currentTarget.value), [onBlur]);

  return (
    <Input
      id={id}
      className={className}
      value={value}
      placeholder={placeholder || "Search elements..."}
      allowClear
      onChange={handleChange}
      onPressEnter={handleSearch}
      onBlur={handleBlur}
      prefix={<SearchOutlined className="me-1" />}
      suffix={suffix}
    />
  )
}

export default memo(AppSearch);